"use client";
import { jsx as I } from "react/jsx-runtime";
import { useState as u, useMemo as f, createContext as w, useContext as P, useEffect as S } from "react";
import { useInkeepConfig as m } from "./config-provider.js";
const g = "conversationId", v = w(null), z = ({ children: t }) => {
  const a = x(), { aiChatSettings: i } = m(), n = i.chatId || a, o = {
    id: "",
    messages: []
  }, [s, r] = u(o), e = () => {
    r(o);
  }, c = f(
    () => ({
      conversation: s,
      setConversation: r,
      chatId: n,
      resetConversation: e
    }),
    [s, n]
  );
  return /* @__PURE__ */ I(v.Provider, { value: c, children: t });
}, L = () => {
  const t = P(v);
  if (!t)
    throw new Error("useInkeepConversation must be used within an InkeepConversationProvider");
  return t;
};
function x() {
  const [t, a] = u(void 0), { aiChatSettings: i } = m(), { shareChatUrlBasePath: n } = i;
  return S(() => {
    if (!n || typeof window > "u") return;
    const o = (e) => e.endsWith("/") ? e.slice(0, -1) : e, s = () => {
      const { origin: e, pathname: c, search: C } = window.location, d = new URL(n), l = o(c), p = o(d.pathname);
      if (e === d.origin && l === p) {
        const h = new URLSearchParams(C).get(g);
        h && a(h);
      }
    };
    s();
    const r = () => s();
    return window.addEventListener("popstate", r), () => {
      window.removeEventListener("popstate", r);
    };
  }, [n]), t;
}
export {
  z as InkeepConversationProvider,
  g as SHARE_QUERY_PARAM,
  L as useInkeepConversation
};
